export const LOGO_URL =
  "https://customer-assets-7cd3h4nn.emergentagent.net/job_wolf-central/artifacts/rs4usde0_E7795FDC-10A3-403C-AA03-94D038758E75.png";

export const NAVY = "#0A192F";
export const GOLD = "#D4AF37";

export const CATEGORIES = ["News", "Legislation", "Community", "Education", "Rescue", "Events"];

export const CATEGORY_COLORS = {
  News: "#0A192F",
  Legislation: "#8B6D1F",
  Community: "#2F5233",
  Education: "#1F4E6B",
  Rescue: "#7A2E2E",
  Events: "#4A3B6B",
};

export const FALLBACK_IMAGE =
  "https://images.unsplash.com/photo-1664573932452-e6307a792b4e?crop=entropy&cs=srgb&fm=jpg&w=1200&q=80";
